module.exports = __webpack_public_path__ + "img/real_estate.1b97b022.webp";